import { render, staticRenderFns } from "./logindDalog.vue?vue&type=template&id=dbd4dd24&scoped=true&"
import script from "./logindDalog.vue?vue&type=script&lang=js&"
export * from "./logindDalog.vue?vue&type=script&lang=js&"
import style0 from "./logindDalog.vue?vue&type=style&index=0&id=dbd4dd24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4dd24",
  null
  
)

export default component.exports